import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = { class: "content p-4 w-100" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "card-title mt-0" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-3 mt-2" }
const _hoisted_7 = { class: "col-3 mt-2" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = { class: "small" }
const _hoisted_10 = { class: "d-flex justify-content-end mt-3" }
const _hoisted_11 = { class: "modal-header justify-content-center pt-3" }
const _hoisted_12 = { class: "row mt-2 mr-3 ml-3 pl-5 v-theme--light" }
const _hoisted_13 = { class: "d-flex justify-content-end m-3" }

import { ref, computed, onMounted } from 'vue';
import { GDialog } from 'gitart-vue-dialog';
import Api from '@/services/api/ApiServiceFabrick';
import { CSV_DATA_EXPORT_FORMATS } from '@/services/consts';
import { formatDate } from '@/services/functions';
import RangeDatePicker from '@/components/Common/RangeDatePicker.vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'CsvDataExport',
  setup(__props) {

const title = i18n.global.t('pages.csvDataExport.title.csvDataExport');

const form = ref({
  format: CSV_DATA_EXPORT_FORMATS[0].value,
  operationOffice: null as any,
  selectDateRange: [new Date(), new Date()] as Date[],
});

const formats = CSV_DATA_EXPORT_FORMATS.map((f) => ({ title: f.title, value: f.value }));
const errors = ref<Record<string, string[]>>({});
const dialogState = ref(false);
const submitting = ref(false);

const submitBtnLabel = computed(() =>
  submitting.value
    ? i18n.global.t('common.downloadingBtn')
    : i18n.global.t('common.downloadBtn')
);

onMounted(() => {
  document.title = title;
});

function isValid(): boolean {
  errors.value = {};
  if (!form.value.operationOffice) {
    errors.value.operationOffice = [i18n.global.t('pages.csvDataExport.messages.operationOfficeRequired')];
  }
  if (!form.value.selectDateRange[0] || !form.value.selectDateRange[1]) {
    errors.value.end_date = [i18n.global.t('pages.csvDataExport.messages.dateRangeRequired')];
  }
  return Object.keys(errors.value).length === 0;
}

function handleClickOutput(): void {
  if (!isValid()) {
    return;
  }

  submitting.value = true;

  const startDate = form.value.selectDateRange[0];
  const endDate = form.value.selectDateRange[1];

  const params = {
    type: form.value.format,
    operation_office_id: form.value.operationOffice.id as number,
    start_date: formatDate(startDate),
    end_date: formatDate(endDate),
  };

  Api().createCsvDataExport(params)
    .then(() => {
      dialogState.value = true;
      submitting.value = false;
    })
    .catch((error) => {
      const res = error.response;
      switch (res?.status) {
        case 401:
        case 403:
          location.reload();
          break;
        case 422:
          errors.value = res.data.errors;
          break;
      }
      submitting.value = false;
    });
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(title)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_select, {
              class: "small mt-2",
              modelValue: form.value.format,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.format) = $event)),
              items: _unref(formats),
              label: _unref(i18n).global.t('pages.csvDataExport.format'),
              clearable: false
            }, null, 8, ["modelValue", "items", "label"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(SingleOperationOfficeAutoComplete, {
              modelValue: form.value.operationOffice,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.operationOffice) = $event)),
              class: "mt-2",
              selectFirstIfOnlyOne: true,
              clearable: false,
              "error-messages": errors.value.operationOffice
            }, null, 8, ["modelValue", "error-messages"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(i18n).global.t('pages.csvDataExport.range')), 1),
            _createVNode(ValidationErrors, {
              messages: errors.value.end_date
            }, {
              default: _withCtx(() => [
                _createVNode(RangeDatePicker, {
                  modelValue: form.value.selectDateRange,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.selectDateRange) = $event)),
                  maxRange: 30,
                  format: "yyyy/MM/dd",
                  isError: !!errors.value.end_date
                }, null, 8, ["modelValue", "isError"])
              ]),
              _: 1
            }, 8, ["messages"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_v_btn, {
            class: "exec-btn",
            onClick: handleClickOutput,
            style: _normalizeStyle({ backgroundColor: submitting.value ? '#B3B8BB' : '' })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(submitBtnLabel.value), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ])
      ])
    ]),
    _createVNode(_unref(GDialog), {
      modelValue: dialogState.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogState).value = $event)),
      "max-width": "30%",
      transition: "custom-from-bottom-transition"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.csvDataExport.completedReception')), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.csvDataExport.messages.acceptedDownload')) + " ", 1),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(i18n).global.t('pages.csvDataExport.messages.outputCompletedAfterEmailNotification')), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_v_btn, {
            class: "m-1 reset-btn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (dialogState.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.close')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})